module.exports = __webpack_public_path__ + "static/media/pi-check.d1bd8a35.svg";